module.exports = __webpack_public_path__ + "assets/img/product-formation.680b03b0.png";